import Menu from './Compartido/Menu.jsx';
import CambiarContrasenya from './CompartidoUsuario/CambiarContrasenya.jsx'
import Footer from './Compartido/Footer.jsx';

const MiContrasenya = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <CambiarContrasenya
                lang={props.lang}
                config={props.config}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default MiContrasenya;
